module.exports = __webpack_public_path__ + "static/media/Pierre.8d753ca5.jpg";